import axios from "axios";

export default {
    state:{
        items:[],
        selecteditem:'',
    },
    mutations:{
        setItems(state,items){
            items.length>0?state.items = items:state.items=[]          
            state.selecteditem=''
        },
        setSelectedItem(state,item){
            state.selecteditem = item
        }
    },
    actions:{
        getItems({commit,rootState,},IdRegimen){
            const token = rootState.Usuario.token
            axios.get(`${rootState.urlapi}/establecimientos/${IdRegimen}`,{headers:{'auth-user':token}})
            .then(response=>{           
                    commit("setItems",response.data)                 
            })     
        },
        setSelectedItem({commit,state},idestablecimiento){
            const item = state.items.find(elemento=>elemento.IdEstablecimiento==idestablecimiento)
            commit("setSelectedItem",item)
        }
    },
    getters:{
        getItems(state){
            return state.items
        },
        getSelectedItem(state){
            return state.selecteditem//items.find(elemento=>elemento.Nit==nit)
        },
        getItemsActivos(state){
            return state.items.filter(elemento=>elemento.Estado=='Activo')
        }
    }
}